import { httpClient } from './httpClient';
import type { AccumulatorRequest, AccumulatorResponse } from '../types/api';

const ACCUMULATOR_PATH = '/LakerApi/GetAccumulatorBySubscriberNum';

/**
 * Fetch deductible / out-of-pocket accumulator values for a member.
 *
 * POST despite being a read — the ext-svc endpoint takes the Laker identity in
 * the body (see WebsiteExternalSvc/Controllers/AccumulatorController.cs).
 */
export async function getAccumulatorBySubscriberNum(
  payload: AccumulatorRequest
): Promise<AccumulatorResponse> {
  const response = await httpClient.post<AccumulatorResponse>(ACCUMULATOR_PATH, payload);
  return response.data;
}
